document.addEventListener("DOMContentLoaded", () => {

  if (typeof DISCOUNT_CONFIGS === 'undefined') return;

  const cookies = document.cookie.toUpperCase();

  const activeConfig = DISCOUNT_CONFIGS.find(cfg =>
    cookies.includes("DISCOUNT_CODE=" + cfg.code) ||
    cookies.includes(cfg.code)
  );

  if (!activeConfig) return;

  document.querySelectorAll(".discount-widget").forEach(widget => {

    const { code, threshold, product, productUrl, reward } = activeConfig;

    widget.innerHTML = `
      <div class="discount-slider">

        <div class="discount-header">

          <div class="gift-wrapper">
            <img src="https://cdn.shopify.com/s/files/1/0553/6556/6511/files/bygge_icon_Geschenk.png?v=1740134180">
          </div>

          <div class="discount-header-text">
            <div class="discount-statusrow">
              <span class="discount-label">Code aktiv</span>
              <div class="discount-code-name"><strong>${code}</strong></div>
            </div>
            <div class="discount-progressbar">
              <div class="discount-progress-fill"></div>
            </div>
          </div>

          <div class="discount-toggle"><span class="arrow">&#9650;</span></div>
        </div>

        <div class="discount-content">
          <p class="discount-info">
            Hurra! Du erh&auml;ltst <strong>${reward}</strong>!
          </p>

          <p class="discount-intro">So kannst du ihn einl&ouml;sen:</p>

          <ul class="discount-todo">
            <li class="step-cart">
              <input type="checkbox" disabled>
              <label>
                Erreiche <strong>${threshold} &euro; Warenkorbwert</strong>
              </label>
            </li>

            <li class="step-product">
              <input type="checkbox" disabled>
              <label>
                Lege <a href="${productUrl}" class="discount-link"><strong>${product.toUpperCase()}</strong></a> in den Warenkorb
              </label>
            </li>
          </ul>

          <p class="discount-status"></p>
        </div>

      </div>
    `;

    const slider      = widget.querySelector(".discount-slider");
    const header      = slider.querySelector(".discount-header");
    const arrow       = slider.querySelector(".arrow");
    const content     = widget.querySelector(".discount-content");
    const progressFill= widget.querySelector(".discount-progress-fill");

    let lastState = "tasks";

    function toggleSlider(force) {
      const open = force !== undefined ? force : !slider.classList.contains("open");
      slider.classList.toggle("open", open);
      arrow.textContent = open ? "\u25BC" : "\u25B2";
    }

    header.addEventListener("click", () => toggleSlider());

    function renderSuccess() {
      content.innerHTML = `
        <div class="discount-success">
          <p class="discount-success-text">
            Super! Dein <strong>${code}</strong>-Geschenk ist aktiv.
          </p>
          <p>
            <a href="/cart">Zum Warenkorb</a><br>
            <a href="/checkout">Direkt zur Kasse</a>
          </p>
        </div>
      `;
    }

    function renderTasks() {
      content.innerHTML = `
        <p class="discount-info">
          Hurra! Du erh&auml;ltst <strong>${reward}</strong>!
        </p>

        <p class="discount-intro">So kannst du ihn einl&ouml;sen:</p>

        <ul class="discount-todo">
          <li class="step-cart">
            <input type="checkbox" disabled>
            <label>
              Erreiche <strong>${threshold} &euro; Warenkorbwert</strong>
            </label>
          </li>

          <li class="step-product">
            <input type="checkbox" disabled>
            <label>
              Lege <a href="${productUrl}" class="discount-link"><strong>${product.toUpperCase()}</strong></a> in den Warenkorb
            </label>
          </li>
        </ul>

        <p class="discount-status"></p>
      `;
    }

    function updateUI(valueOK, productOK, done) {
      const sCart  = content.querySelector(".step-cart");
      const sProd  = content.querySelector(".step-product");
      const status = content.querySelector(".discount-status");

      if (sCart) {
        sCart.classList.toggle("done", valueOK);
        sCart.querySelector("input").checked = valueOK;
      }

      if (sProd) {
        sProd.classList.toggle("done", productOK);
        sProd.querySelector("input").checked = productOK;
      }

      progressFill.style.width = (done / 2 * 100) + "%";
      progressFill.classList.toggle("full", done === 2);

      if (status) {
        if (done === 0) status.textContent = "Erf\u00fclle beide Schritte, um dein Geschenk zu sichern!";
        else if (done === 1) status.textContent = "Fast geschafft \u2013 noch ein Schritt!";
        else status.textContent = "";
      }
    }

    function update() {
      fetch("/cart.js")
        .then(r => r.json())
        .then(cart => {

          const valueOK = cart.total_price / 100 >= threshold;
          const productOK = cart.items.some(i =>
            i.title.toLowerCase().includes(product)
          );

          const done = (valueOK ? 1 : 0) + (productOK ? 1 : 0);

          if (done === 2 && lastState !== "success") {
            lastState = "success";
            renderSuccess();
            toggleSlider(true);
          }
          else if (done < 2 && lastState !== "tasks") {
            lastState = "tasks";
            renderTasks();
          }

          updateUI(valueOK, productOK, done);
        });
    }

    update();

    // Update on cart changes instead of constant polling
    // Listen for cart AJAX events (Section Rendering API)
    var origFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var result = origFetch.apply(this, args);
      if (url.indexOf('/cart/') !== -1 && url.indexOf('/cart.js') === -1) {
        result.then(function() { setTimeout(update, 500); });
      }
      return result;
    };

    // Also check when page becomes visible (user returns to tab)
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) update();
    });

  });
});
